import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Router Other Links',
  basePath: '/router-other-links',
  rowKey: 'pid',
  columns: [
    { key: 'var', label: 'Position', sortable: true },
    { key: 'article_title', label: 'Article', sortable: true },
  ],
  fields: [
    { key: 'pid', label: 'ID', type: 'hidden' },
    { key: 'var', label: 'Position', type: 'select',
      options: [
        { label: 'About us', value: 'about' },
        { label: 'Advertising', value: 'advertising' },
        { label: 'Community', value: 'community' },
        { label: 'Cookies Policy', value: 'cookies' },
        { label: 'Consulting', value: 'consulting' },
        { label: 'Contact', value: 'contact' },
        { label: 'Marketing', value: 'marketing' },
        { label: 'Partners', value: 'partners' },
        { label: 'Privacy Policy', value: 'privacy-policy' },
        { label: 'Terms and Conditions', value: 'terms-conditions' },
      ],
      required: true },
    { key: 'article_id', label: 'Article', type: 'async-select',
      optionsUrl: '/articles/options', required: true },
  ],
  defaultSort: { field: 'var', dir: 'asc' },
});
